import { useState } from 'react';
import api from '../../utils/api';

export default function AdminImportExport() {
  const [message, setMessage] = useState('');

  const handleExport = () => {
    window.open(`${api.defaults.baseURL}/api/admin/products/export`, '_blank');
  };

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await api.post('/api/admin/products/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setMessage(res.data);
    } catch (err) {
      setMessage('Import failed');
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Import / Export</h2>
      <div className="space-y-4">
        <div>
          <p className="font-semibold mb-2">Export Products</p>
          <button onClick={handleExport} className="bg-black text-white px-4 py-2">Download CSV</button>
        </div>
        <div>
          <p className="font-semibold mb-2">Import Products (CSV)</p>
          <input type="file" accept=".csv" onChange={handleImport} className="text-sm" />
        </div>
        {message && <p className="text-sm text-gray-500 mt-2">{message}</p>}
      </div>
    </div>
  );
}